const getOrCreateTooltip = (chart) => {
  let tooltipElement = chart.canvas.parentNode.querySelector("div");

  if (!tooltipElement) {
    tooltipElement = document.createElement("div");
    tooltipElement.style.background = "white";
    tooltipElement.style.boxShadow =
      "0px 6px 10px -4px rgba(0, 0, 0, 0.15), 0px 2px 2px rgba(40, 40, 40, 0.1)";
    tooltipElement.style.borderRadius = "4px";
    tooltipElement.style.color = "black";
    tooltipElement.style.maxWidth = "220px";
    tooltipElement.style.width = "100%";
    tooltipElement.style.opacity = 1;
    tooltipElement.style.pointerEvents = "none";
    tooltipElement.style.position = "absolute";
    tooltipElement.style.transform = "translate(-100%, 0)";
    tooltipElement.style.transition = "all .1s ease";
    tooltipElement.style.zIndex = 1000;

    const table = document.createElement("table");
    table.style.margin = "0px";

    tooltipElement.appendChild(table);
    chart.canvas.parentNode.appendChild(tooltipElement);
  }

  return tooltipElement;
};

export const patientChartTooltipHandler = (context) => {
  const { chart, tooltip } = context;

  const dataPoint = tooltip.dataPoints?.[0];
  const dataPoints = context.tooltip.dataPoints;

  const {
    label,
    dataIndex,
    dataset: { data },
  } = dataPoint;

  const tooltipElement = getOrCreateTooltip(chart);

  // Hide if no tooltip or no data for the given dataIndex
  if (!data?.[dataIndex] || tooltip.opacity === 0) {
    tooltipElement.style.opacity = 0;
    return;
  }

  // Set Text
  if (tooltip?.body && tooltip?.body?.length > 0) {
    const table = tooltipElement.querySelector("table");
    table.style.width = "100%";

    const tableHead = document.createElement("thead");
    const firstRow = document.createElement("tr");

    const titleElement = document.createElement("span");
    titleElement.textContent = label;
    titleElement.style.fontSize = "14px";
    titleElement.style.fontWeight = 600;

    firstRow.appendChild(titleElement);
    tableHead.appendChild(firstRow);

    const tableBody = document.createElement("tbody");

    if (dataPoints?.length > 0) {
      dataPoints
        ?.sort((a, b) => b?.raw - a?.raw)
        ?.forEach(
          ({ dataIndex, dataset: { label, backgroundColor, data } }) => {
            const deviceCount = data?.[dataIndex];

            const blockElement = document.createElement("tr");
            const contentElement = document.createElement("td");
            const valueElement = document.createElement("td");
            valueElement.setAttribute("align", "right");

            contentElement.textContent = label;

            valueElement.style.textAlign = "right";
            valueElement.textContent = `${deviceCount}`;
            valueElement.style.fontWeight = 400;

            blockElement.appendChild(contentElement);
            blockElement.appendChild(valueElement);
            tableBody.append(blockElement);

            const span = document.createElement("span");

            span.style.background = backgroundColor;
            span.style.borderWidth = "2px";
            span.style.borderRadius = "50%";
            span.style.marginRight = "5px";
            span.style.width = "10px";
            span.style.height = "10px";
            span.style.display = "inline-block";

            contentElement.prepend(span);
          }
        );
    }

    // Remove old children
    while (table.firstChild) {
      table.firstChild.remove();
    }

    // Add new children
    table.appendChild(tableHead);
    table.appendChild(tableBody);
  }

  const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;

  // Display, position, and set styles for font
  tooltipElement.style.opacity = 1;
  tooltipElement.style.left = positionX + tooltip.caretX + "px";
  tooltipElement.style.top = positionY + tooltip.caretY + "px";
  tooltipElement.style.font = tooltip.options.bodyFont.string;
  tooltipElement.style.padding =
    tooltip.options.padding + "px " + tooltip.options.padding + "px";
};
